export default __webpack_public_path__ + "static/media/cyberessentials_certification-mark-plus_colour.65e862a3.webp";